import { IS_RECOGNIZED } from '../../constants/custom-data-elements';
import { VSB_UNBIND_ERROR } from '../../constants/vsb-enums';
import getIdToken from '../../helpers/get-id-token';
import getSuccessFulUnbindCount from '../../helpers/get-successful-unbind-count';
import isEmptyString from '../../helpers/is-empty-string';
import orchCustomData from '../../helpers/orch-custom-data';
import resetCustomData from '../../helpers/reset-data';
import unbindAppInstance from '../unbind-app-instance';

/**
 * Buttonless wrapper for unbindAppInstance api.
 * This is what is bound to "V" namespace for merchant to
 * call in integrated Vsb flows. Wrapper is needed to keep
 * integrated/buttonless specific logic and response handling
 * separate from unbindAppInstance orch api
 * @param {object} data object with key idToken, value array of idToken string
 */

const unbindAppInstanceForButtonless = (data = {}) => {
  return new Promise(resolve => {
    let requestData;
    const idTokens = getIdToken();
    // support vsb passing idToken array in object
    if (Array.isArray(data.idTokens) && !isEmptyString(data.idTokens[0])) {
      requestData = { idToken: data.idTokens[0] };
    } else {
      requestData =
        idTokens && Array.isArray(idTokens) && idTokens.length > 0 && !isEmptyString(idTokens[0])
          ? { idToken: idTokens[0] }
          : {};
    }
    unbindAppInstance(requestData).then(res => {
      // clear idToken cache
      if (idTokens.length) {
        orchCustomData.updateIdToken();
      }
      // clear out isRecognized promise cache
      resetCustomData(IS_RECOGNIZED);
      orchCustomData.clearApiResponseCache();

      const successfulUnbindCount = getSuccessFulUnbindCount(res);

      if (!orchCustomData.isVsb) {
        resolve();
      } else if (successfulUnbindCount > 0) {
        resolve({});
      } else {
        resolve({
          error: VSB_UNBIND_ERROR
        });
      }
    });
  });
};

export default unbindAppInstanceForButtonless;
